module.exports = __webpack_public_path__ + "05dd41945d500890cb798f55dc437a79.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/default/variant-naming/img1.png
// module id = 1313
// module chunks = 0